import { Drawer } from 'components/Drawer'
import { Heading } from 'blaze-ui/Heading/Heading'
import { RatingSegmentedControl } from 'components/RatingsExtraFeedbackDrawer/RatingSegmentedControl'
import { RatingsExtraFeedbackDrawerProps } from 'components/RatingsExtraFeedbackDrawer/Types'
import { useUpdateFeedback } from 'hooks/queries/feedbacks/useUpdateFeedback'
import Styles from './RatingsExtraFeedbackDrawer.module.scss'
import React, { useCallback, useState } from 'react'
import { PressEvent } from '@react-types/shared/src/events'
import { Button } from 'blaze-ui/Button'
import { useRootStore } from 'stores/RootStore'
import { FeedbackTextField } from 'components/RatingsExtraFeedbackDrawer/FeedbackTextField'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { CheckBroken } from 'blaze-ui/icons'
import { FeedbackChips } from 'components/RatingsExtraFeedbackDrawer/FeedbackChips'

export const RatingsExtraFeedbackDrawer = ({ feedback, ...drawerProps }: RatingsExtraFeedbackDrawerProps) => {
  const { drawersStore } = useRootStore()
  const { closeDrawer } = drawersStore
  const [updatedFeedback, setUpdatedFeedback] = useState(feedback)
  let { mutate } = useUpdateFeedback(feedback.id, {
    onSettled: (data) => {
      data && setUpdatedFeedback(data)
    },
  })

  const [customFeedback, setCustomFeedback] = useState('')

  const handleFeedback = useCallback(
    (e: PressEvent) => {
      const feedback = e.target.getAttribute('data-key')

      if (!feedback) return

      mutate({
        feedback: {
          ...updatedFeedback.feedback,
          [feedback]: !updatedFeedback.feedback?.[feedback],
        },
      })
    },
    [mutate, updatedFeedback],
  )

  const handleSubmit = useCallback(() => {
    mutate({
      feedback: {
        ...updatedFeedback.feedback,
        feedback: customFeedback,
      },
    })
    showToastMessage('Your rating has been submitted', 'designRating', undefined, undefined, <CheckBroken size={24} />)
    closeDrawer()
  }, [customFeedback, updatedFeedback, mutate, closeDrawer])

  return (
    <Drawer.Root {...drawerProps}>
      <Drawer.Portal>
        <Drawer.Content>
          <Drawer.InnerContent>
            <Drawer.Top>
              <div />
              <Drawer.Title asChild>
                <Heading lineClamp={1} level={5}>
                  Thanks for your feedback
                </Heading>
              </Drawer.Title>
              <Drawer.Close label="Close" variant="ghost" position="right" />
            </Drawer.Top>
            <Drawer.Container>
              <div className={Styles.content}>
                <RatingSegmentedControl
                  isFullWidth
                  rounded
                  variant="secondary"
                  onItemClick={(item) => {
                    mutate({
                      rating: item as string,
                    })
                  }}
                  activeItem={updatedFeedback.rating}
                />
                {updatedFeedback.rating === 'downvote' && (
                  <div className={Styles.feedback}>
                    <Heading level={5}>What could be improved?</Heading>
                    <div className={Styles.feedbacks}>
                      <FeedbackChips onChipPress={handleFeedback} feedback={updatedFeedback} />
                    </div>
                  </div>
                )}
                <FeedbackTextField name="feedback" value={customFeedback} onChange={setCustomFeedback} />
                <Button fullWidth size="lg" onPress={handleSubmit}>
                  Submit Feedback
                </Button>
              </div>
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
}
